import { useEffect, useState } from "react";

export const useCountSum = (elements = []) => {
  const [countResul, setCountResul] = useState(0);

  useEffect(() => {
    const count = elements.reduce((total, el) => total + el.total, 0);
    setCountResul(count.toLocaleString("en-US"));
  }, [elements]);

  return {
    countResul,
  };
};
